import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import type { Mood, SessionSummary } from '@/lib/types';

type UpdatePracticeSessionRequest = {
  sessionId: string;
  mood?: Mood | null;
  notes?: string;
  durationMinutes?: number;
};

export function useUpdatePracticeSession(): ReturnType<
  typeof useMutation<SessionSummary, Error, UpdatePracticeSessionRequest>
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ sessionId, ...data }: UpdatePracticeSessionRequest) => {
      const body: Record<string, unknown> = {};
      if ('mood' in data) body['mood'] = data.mood ?? null;
      if ('notes' in data) body['notes'] = data.notes;
      if ('durationMinutes' in data) body['durationMinutes'] = data.durationMinutes;
      return api.fetch<SessionSummary>(`/practice-sessions/${sessionId}`, {
        method: 'PATCH',
        body: JSON.stringify(body),
      });
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: ['practice-session-summary', variables.sessionId],
      });
    },
  });
}
